import { ObjectRule } from '@/classes/rules/ObjectRule';
import { DefaultValue } from '@/classes/rules/DefaultValue';
import { ScenarioExt } from '@/classes/scenario/ScenarioExt';
import { InjectionModelRef } from '@/dto/scenario/ScenarioReference';
import { ProjectTypeRef } from '@/dto/scenario/ProjectReference';
import { ScenarioRenFrPVExt } from '@/classes/scenario/ren-fr/pv/ScenarioRenFrPVExt';
import { MinMaxRule } from '@/classes/rules/MinMaxRule';

export const buildRenFrPvRules = () => new ObjectRule<ScenarioRenFrPVExt>('ren_fr_pv', [
  new MinMaxRule('unit_power'),
  new MinMaxRule('module_area'),
  new MinMaxRule('p50_annual_degradation'),
  new MinMaxRule('p90_annual_degradation'),
  new MinMaxRule('installed_capacity'),
  new MinMaxRule('dc_ac_ratio'),

  new MinMaxRule('net_p50'),
  new MinMaxRule('net_p90'),
  new MinMaxRule('numberOfPdl'),
  new MinMaxRule('numberOfPdlPtr'),
  new MinMaxRule('numberOfPtr')
])
  .withIsAvailable(scenario => isRenFrancePVProject(scenario))
  .withDefaultValue(() => new DefaultValue(new ScenarioRenFrPVExt()));

function isRenFrancePVProject(scenario: ScenarioExt): boolean {
  return (scenario.project?.typeRef === ProjectTypeRef.ren_fr_pv_project) &&
    scenario.hasInjectionType(InjectionModelRef.total_injection);
}
